import {useCallback} from 'react';

import {useMaybeSemanticLegendPalette} from '../../hooks';
import {YAxisValues} from '../../types';
import {
  SEMANTIC_LEGEND_PALETTE_CATEGORICAL_CONFIG_DEFAULT,
  SEMANTIC_LEGEND_PALETTE_DEFAULT,
} from './colorPalettes';

export const useGetWorkspaceSettingsSemanticLegendPaletteWithCategoricalConfig =
  () => {
    const semanticLegendPalette = useMaybeSemanticLegendPalette();
    return useCallback(
      (yAxisValue: YAxisValues | undefined) => {
        if (yAxisValue === YAxisValues.Config_Categories) {
          return (
            semanticLegendPalette ??
            SEMANTIC_LEGEND_PALETTE_CATEGORICAL_CONFIG_DEFAULT
          );
        }
        return semanticLegendPalette ?? SEMANTIC_LEGEND_PALETTE_DEFAULT;
      },
      [semanticLegendPalette]
    );
  };
